import {
    AggregationStrategy,
    BuyGroupName,
    NetGroupName,
    PortfolioSummarySortableDataItem,
    SellGroupName,
    ShortGroupName,
    SidesGroupName,
    TotalGroupName,
} from './AggregationStrategy';
import {
    initialiseGroup,
    PortfolioSummaryAggregatedData,
} from 'widgets/portfolioSummary/store/data/PortfolioSummaryDataState';
import { PortfolioItem } from 'portfolio/PortfolioItem';
import { AggregationField } from '../fields/aggregationFieldPortfolio';
import { OrderSide } from 'communication/types/order/OrderSide';

const SideGroupOrder: string[] = [
    TotalGroupName,
    NetGroupName,
    BuyGroupName,
    SellGroupName,
    ShortGroupName,
];

export class SideAggregationStrategy implements AggregationStrategy {
    public aggregationField: AggregationField = 'side';

    public constructor(public combineSellsAndShorts: boolean) {}

    public initialiseAggregatedData() {
        const group = initialiseGroup(
            SidesGroupName,
            this.combineSellsAndShorts
        );

        group.total.selectionDisabled = true;
        group.net.selectionDisabled = true;
        const data = {
            [SidesGroupName]: group,
        };
        return data;
    }

    public getAggregationGroup(
        data: PortfolioSummaryAggregatedData,
        _item: PortfolioItem
    ) {
        return data[SidesGroupName];
    }

    public filterPortfolio(
        filteredPortfolio: PortfolioItem[],
        groupName: string
    ): PortfolioItem[] {
        const groupSide = this.groupNameToValue(groupName);

        return filteredPortfolio.filter(
            (item) =>
                item.side === groupSide ||
                (item.side === 'SS' &&
                    groupSide === 'S' &&
                    this.combineSellsAndShorts)
        );
    }

    public getDrillDowns(
        data: PortfolioSummaryAggregatedData,
        item: PortfolioItem
    ) {
        const side = item.side;
        const groupName = this.sideToGroupName(side);
        return data[groupName]?.drillDowns;
    }

    public sort(
        x: PortfolioSummarySortableDataItem,
        y: PortfolioSummarySortableDataItem
    ): number {
        return (
            SideGroupOrder.indexOf(x.groupName) -
            SideGroupOrder.indexOf(y.groupName)
        );
    }

    public groupNameToValue(groupName: string): OrderSide {
        return groupName === BuyGroupName
            ? 'B'
            : groupName === SellGroupName
            ? 'S'
            : 'SS';
    }

    private sideToGroupName(side: OrderSide) {
        switch (side) {
            case 'B':
                return BuyGroupName;
            case 'S':
                return SellGroupName;
            default:
                return this.combineSellsAndShorts
                    ? SellGroupName
                    : ShortGroupName;
        }
    }
}
